import React, { useState } from 'react';
import styles from './Financial.module.css';
import Categories from './areas/categories/Categories';
import TransactionsPage from './TransactionsPage';
import RoleGuard from '../../components/guards/RoleGuard';
import AccessDenied from '../../components/access-denied/AccessDenied';
import FinancialLockedPreview from './FinancialLockedPreview';

const AREAS = [
  { id: 0, label: "Transações" },
  { id: 1, label: "Categorias" }
];

function Financial() {
  const [currentArea, setCurrentArea] = useState(AREAS[0].id);

  function GetArea() {
    switch (currentArea) {
      case 0:
        return (<TransactionsPage />);
      case 1:
        return (<Categories />);
      default:
        return (<div></div>);
    }
  }

  return (
    <RoleGuard
      access="financial"
      fallback={(
        <AccessDenied
          title="O financeiro fica com quem administra a conta"
          description="Entradas, saídas e categorias aparecem para Administrador(a) e Proprietário(a)."
          hint="Peça a quem é proprietário(a) da conta para mudar o seu papel em Usuários."
          preview={<FinancialLockedPreview />}
        />
      )}
    >
      <div className='page-content'>
        <div className={styles.mainContainer}>
          {/* Abas de verdade para o leitor de tela (tablist / tab / tabpanel) */}
          <div className={styles.tabs} role="tablist" aria-label="Financeiro">
            {AREAS.map(area => {
              const active = currentArea === area.id;
              return (
                <button
                  key={area.id}
                  type="button"
                  role="tab"
                  id={`financial-tab-${area.id}`}
                  aria-selected={active}
                  aria-controls="financial-tabpanel"
                  className={`${styles.tab} ${active ? styles.tabActive : ''}`}
                  onClick={() => setCurrentArea(area.id)}
                >
                  {area.label}
                </button>
              );
            })}
          </div>
          {/* O conteúdo responde à largura da área (@container financial), não à janela */}
          <div
            className={styles.containerArea}
            role="tabpanel"
            id="financial-tabpanel"
            aria-labelledby={`financial-tab-${currentArea}`}
          >
            {GetArea()}
          </div>
        </div>
      </div>
    </RoleGuard>
  );
}

export default Financial;
